import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { authApi } from '../services/api';

interface Usuario {
  id: string;
  nome: string;
  email: string;
  admin: boolean;
}

interface AuthContextType {
  usuario: Usuario | null;
  logado: boolean;
  login: (email: string, senha: string) => Promise<void>;
  logout: () => void;
  carregando: boolean;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('monchery_token');
    if (token) {
      authApi.me()
        .then(res => setUsuario(res.data))
        .catch(() => localStorage.removeItem('monchery_token'))
        .finally(() => setCarregando(false));
    } else {
      setCarregando(false);
    }
  }, []);

  const login = async (email: string, senha: string) => {
    const res = await authApi.login(email, senha);
    const { token, usuario } = res.data;
    localStorage.setItem('monchery_token', token);
    setUsuario(usuario);
  };

  const logout = () => {
    localStorage.removeItem('monchery_token');
    setUsuario(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ usuario, logado: !!usuario, login, logout, carregando }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth deve ser usado dentro de AuthProvider');
  return context;
}
